window.onload = () => {
    const formInput = document.querySelector(".search-suggest");
    formInput.classList.add("search-form__input");
    formInput.setAttribute("placeholder", "Поиск...");
};




